import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import { MenuMappingService } from "../../../services/index";

@Component({
  selector: "menuMapping-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./menuMapping.component.html",
})
export class MenuMapping implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  gridOptions: any;
  isLoadMask: Promise<any>;
  userlist: any = [];
  userDetails: any = [];
  modeList = ["Active", "InActive"];
  userdata: any = {};
  objdata: any = {};
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  is_show: boolean = false;
  is_save: boolean = false;


  list: any = [];
  configdata: any = [];
  config: any = [];
  menu: any = [];
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "id",
    orderDir: "asc",
  };
  userCtrl: FormControl = new FormControl();
  @Output() tabUpdateEvent = new EventEmitter();

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate1") editDeleteTemplate1: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData = {
    nameCode: "",
  };
  menudata: any = [];

  constructor(
    private menumapService: MenuMappingService,
    public toasterService: ToasterService
  ) { }

  ngOnInit(): void {
    this.getUserList();

    /* this.list = 
          [{
              title: 'MASTER',
              config:[{
                  title:'Edit Button',
                  name:'edit',
                  status:true,
              },{
                  title:'Add Button',
                  name:'add',
                  status:true,
              },{
                  title:'Delete Button',
                  name:'delete',
                  status:true,
              },{
                  title:'Hide Box Name',
                  name:'hidebox',
                  status:true,
              }],
              expand: false,
              children: [{
                  title: 'CBM',
              config:[{
                  title:'CBM Edit Button',
                  name:'edit',
                  status:true,
              }],
  
                  expand: false,
                  children:[{
                      title:'Add Cbm',
              config:[{
                  title:'CBM Add Button',
                  name:'add',
                  status:true,
              }],
  
                      expand:false,
                      children:[]
                  }]
              },{
                  title: 'ITEM',
              config:[{
                  title:'Item Delete Button',
                  name:'delete',
                  status:true,
              }],
  
                  expand: false,
                  children:[{
                      title:'Add Item',
              config:[{
                  title:'Hide Box Name',
                  name:'hidebox',
                  status:true,
              }],
  
                      expand:false,
                      children:[] 
              }]
          }]
      },
              {
              title: 'TRANSACTION',
              config:[{
                  title:'PO Print Button',
                  name:'hide print',
                  status:true,
              },{
                  title:'OP Party Name',
                  name:'hide party',
                  status:true,
              },{
                  title:'GeneratePO Button',
                  name:'hide generatepo btn',
                  status:true,
              }],
  
              expand: false,
              children: [{
                  title:'PURCHASE ORDER',
              config:[{
                  title:'PO Print Button',
                  name:'hide print',
                  status:true,
              }],
  
                  expand:false,
                  children:[{
                      title:'Add Purchase Order',
              config:[{
                  title:'OP Party Name',
                  name:'hide party',
                  status:true,
              }],
  
                      expand:false,
                      children:[]
                  }]
              },{
                  title:'ORDER PLANNER',
              config:[{
                  title:'GeneratePO Button',
                  name:'hide generatepo btn',
                  status:true,
              }],
  
                  expand:false,
                  children:[]
              }]
      }];*/
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    // this.getUserList();
  }
  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
      }
      if (event.keyCode === 27) {
      }
    }
  }

  generateConfig(e) {
    console.log(e);
    this.config = [];

    this.config = e.config;
  }
  check() {
    console.log(this.list);
    console.log(this.config);
  }
  // menucheck(menu, ischecked) {
  //   for (let i = 0; i < menu.children.length; i++) {
  //     menu.children[i].ischecked = ischecked;
  //     let menu1 = menu.children[i];
  //     this.menucheck(menu1, ischecked);
  //   }
  // }
  configcheck(config, isselect) {
    for (let i = 0; i < config.length; i++) {
      config[i].isselect = isselect;
    }
  }
  /* doUnCHeck(menu){
         let isChecked = false;
         for(let i = 0 ; i<menu.length;i++){
             this.doUnCHeck(menu[i].children);
             isChecked = isChecked || menu[i].isChecked;
 
         }
          menu.isChecked = isChecked;
        
     }*/
  editUser() {
    this.is_show = true;
    this.is_save = false;
    let temp = this.userlist.filter(el => el.userid == this.userdata.id);

    if (temp.length == 0) {
      this.objdata.username = "";
      this.objdata.password = "";
      this.objdata.fullname = "";
      this.objdata.status = "Active";
      this.userDetails.push({ ...this.objdata });

    }
    else {
      this.userDetails.push(temp[0]);
    }
    console.log(this.userDetails)

  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "fullname" && nxtRow.length == 0 && !this.userdata.id) {
      let rowdetail = Object.assign({}, this.objdata);
      this.userDetails.push({ ...rowdetail });
      let Ind = nxtInd + 1;
      $("#" + fld + "-" + Ind).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  doUnCHeck(children) {
    console.log(children);
    let isChecked = false;
    for (let i = 0; i < children.length; i++) {
      let child = children[i];
      child.isChecked = child.isChecked || this.doUnCHeck(child.children);
      isChecked = isChecked || child.isChecked;
    }
    return isChecked;
  }

  /* doUnCHeck(menu){
         for(let i = 0 ; i<menu.length;i++){
             for(let j=0 ; j<menu[i].children; j++){
                 if(menu[i].children[j].ischecked == true){
                      menu[i].ischecked = true;
                 }
                 else{
                     menu[i].ischecked = false;
                 }
             }
         }
     }*/

  childcheck(menu) {
    let that = this;
    that.hasChild(that.list, menu);
    // that.doUnCHeck(that.list);
  }

  hasChild(parent, child) {
    for (let i = 0; i < parent.length; i++) {
      if (parent[i].menu_name == child.menu_name) {
        return true;
      } else {
        if (this.hasChild(parent[i].children, child)) {
          parent[i].ischecked = true;
          return true;
        }
      }
    }

    return false;
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getUserList();
  }

  getUserList(): void {
    let that = this;
    that.menumapService
      .getUserList({})

      .then((res: any) => {
        that.userlist = res.data;
      });
  }
  getList() {
    this.is_save = true;
    this.is_show = false;

    if (!(this.userdata.id > 0)) {
      return;
    }
    let that = this;
    that.menumapService
      .getList({
        user_id: this.userdata.id,
      })

      .then((res: any) => {
        that.list = res;

        that.list.forEach((el, ind) => {
          if (el.children)
            el.children.forEach((e, i) => {
              if (e.ischecked)
                that.list[ind].ischecked = true;
            });
        });


        // that.list.forEach((el,ind) => {
        //   if(el.children)
        //    var ch = el.children.findIndex(x => x.ischecked === true);
        //    if(ch !== -1)
        //     that.list[ind].ischecked = true;
        // });

        that.config = [];
      });
  }

  savemapping() {
  
    let that = this;
    let params = {
      user_id: this.userdata.id,
      data: JSON.stringify(this.list),
    };
    swal({
      title: "Are you sure to Save?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.menumapService
        .savemapping(params)
        .then(function (res: any) {
          if (res.success) {
            /* this.toasterService.pop({
                           bodyOutputType: 1,
                           type: 'success',
                           title: 'SUCCESS',
                           body: res.message
                       });*/
            swal(
              "SUCCESS",
              "Menu Mapping Details Successfully Saved!",
              "success"
            );
       
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
       
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
          //console.log(error);
        });
    });
    this.is_save = false;
  }
  addEditUserdet() {
    console.log(this.list);
    let that = this;
    let params = {
      userDet: JSON.stringify(this.userDetails),
    };
    swal({
      title: "Are you sure to Save?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.menumapService
        .addEditUserdet(params)
        .then(function (res: any) {
          if (res.success) {
            /* this.toasterService.pop({
                           bodyOutputType: 1,
                           type: 'success',
                           title: 'SUCCESS',
                           body: res.message
                       });*/
            swal(
              "SUCCESS",
              "User Details Successfully Saved!",
              "success"
            );
            let tabObj = {
              action: "CloseTab",
              params: {},
            };
            that.tabUpdateEvent.emit(tabObj);
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
          //console.log(error);
        });
    });
    this.is_show = false;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/menuMapping/menuMapping.component.ts